<template>
	<div class="d-flex justify-content-between w-100">
		<label id="hideinmobile" v-if="!noLabel" class="teams-label-font w-16"
			>{{ label
			}}<span
				v-if="mandatory"
				class="asterik"
				:class="formID == 'project' ? 'project-desc-asterik' : ''"
				>*</span
			></label
		>

		<div
			class="d-flex align-items-center position-relative pl-0 textarea-component"
			:class="formID == 'personalDetails' ? 'input-w84' : 'w-100'"
		>
			<div
				class="floating-label"
				:class="formID == 'personalDetails' ? 'extra-space' : ''"
			>
				<b-form-textarea
					:id="id"
					class="com-textarea"
					:placeholder="placeholder"
					:type="type"
					v-model.trim="inputData"
					@focus="isFocused = true"
					@input="handleInput()"
					@blur="$emit('handle-blur')"
					:class="showError ? 'error' : 'phonenumber-input'"
					rows="3"
					:maxLength="limit"
					no-resize
				></b-form-textarea>

				<label
					v-if="!noLabel"
					id="hideinlaptop"
					:class="{ active: isFocused || inputData }"
					>{{ label
					}}<span v-if="mandatory" class="asterik">&nbsp;*</span></label
				>
			</div>
			<div
				v-if="id == 'profileSummary'"
				class="mobile-extra-space"
				:class="showError ? 'mobile-extra-red-border' : ''"
			>
				<FloatingButton
					@button-click="getProfileSummary"
					:loadingShow="floatLoader"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import FloatingButton from "./FloatingButton.vue";
import { getProfileSummary } from "@/utils/apiFunctions";
import { maxLength } from "vuelidate/lib/validators";
export default {
	data() {
		return {
			isFocused: false,
			inputData: "",
			floatLoader: false,
		};
	},
	props: {
		noLabel: Boolean,
		disabled: Boolean,
		mandatory: Boolean,
		showError: Boolean,
		type: String,
		label: String,
		placeholder: String,
		id: String,
		fieldType: String,
		formID: String,
		newObject: Object,
		limit: Number,
		vmodel: {
			validator: function () {
				return true;
			},
		},
	},
	watch: {
		vmodel(newValue) {
			this.inputData = newValue;
		},
		floatLoader(newValue) {
			this.$emit("loading-status", newValue);
		},
	},
	components: {
		FloatingButton,
	},
	computed: {
		...mapGetters("candidateVUEX", {
			candidateInfo: "getcandidateInfo",
		}),
	},
	created() {
		if (this.vmodel) {
			this.inputData = this.vmodel;
			this.$emit("select-value", this.inputData);
		}
		console.log(this.fieldType, this.type);
	},
	methods: {
		handleInput() {
			if (this.type === "email") {
				this.inputData = this.inputData.toLowerCase();
			}
			this.$emit("select-value", this.inputData);
			this.$emit("handle-input");
		},
		async getProfileSummary() {
			this.floatLoader = true;
			let payload = {
				candidate: {
					...this.candidateInfo,
					...this.newObject,
				},
			};
			payload.candidate.profileSummary = "";
			const res = await getProfileSummary(payload);
			if (res.status == 200) {
				this.inputData = res.data.summary;
				this.$emit("select-value", this.inputData);
			}
			this.floatLoader = false;
		},
	},
};
</script>

<style>
.textarea-component .form-control {
	border-radius: 8px;
	color: #333333;
}
.textarea-component .form-control:focus {
	box-shadow: none;
}
.textarea-component .floating-label label {
	top: 24%;
}

.textarea-component .floating-label input:focus + label,
.textarea-component .floating-label label.active {
	top: -4px;
}
.mobile-extra-space {
	height: 45px;
	left: 1%;
	width: 97%;
	position: absolute;
	background-color: #ffffff;
	z-index: 6;
	bottom: 3px;
	border-radius: 0 0 8px 8px;
}
.mobile-extra-red-border {
	border-color: #eb0002 !important;
}
.hide-slash {
	background-color: white;
	height: 5px;
	width: 8px;
	right: 1px;
	bottom: 48px;
	position: absolute;
}
.extra-space .form-control {
	padding-bottom: 50px;
}
@media (max-width: 1028px) {
	.textarea-component .form-control::placeholder {
		color: #ffffff;
	}
	.textarea-component .form-control::-webkit-scrollbar {
		width: 5px !important;
		height: 5px !important;
	}

	.mobile-extra-space {
		height: 50px;
		width: 97%;
		position: absolute;
		left: 0;
		background-color: #ffffff;
		z-index: 6;
		bottom: 0px;
		border-bottom: 1px solid #ced4da;
		border-left: 1px solid #ced4da;
		border-radius: 0 0 0px 8px;
		display: flex;
		justify-content: center;
	}
}
</style>
